import React from 'react';

import { ReactActionDialogBodyProps } from '~src/commonInfra/dialogs/ReactActionDialog';
import { EditConnectionDialogBridgeInfo} from '~src/connectivity/components/EditConnection/components/EditConnectionActionDialogBridgeInfo';
import { EditConnectionDialogPrompt } from '~src/connectivity/components/EditConnection/components/EditConnectionActionDialogPrompt';
import { EditFilebasedConnectionDialogProps, EditFilebasedConnectionDialogState } from '~src/connectivity/components/EditFilebasedConnection/EditFilebasedConnectionAction';

export type EditConnectionDialogBodyReactActionProps = ReactActionDialogBodyProps<
  EditFilebasedConnectionDialogProps,
  EditFilebasedConnectionDialogState
  >;

export function EditFilebasedConnectionActionDialogBody(props: EditConnectionDialogBodyReactActionProps) {
  function updateFormState<K extends keyof EditFilebasedConnectionDialogState>(
    field: K,
    value: EditFilebasedConnectionDialogState[K]
  ) {
    props.updateDialogState({ [field]: value });
  }

  return (
    <>
      <EditConnectionDialogPrompt prompt={props.prompt} />
      <div style={{ width: '100%' }}>
        <EditConnectionDialogBridgeInfo
          usingRemoteQueryAgent={props.dialogState.usingRemoteQueryAgent}
          handleUsingRemoteQueryAgentChange={(value) => updateFormState('usingRemoteQueryAgent', value)}
          showNetworkType={props.showNetworkType}
        />
      </div>
    </>
  );
}
